var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransit1Off(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 33.5,
    r: 8.5,
    fill: "#9D9EB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4141 8.29297V23.042C32.1128 23.016 31.808 23 31.5 23C31.1095 23 30.7242 23.0229 30.3447 23.0645V10.6279L17.2412 16.9316V33.5645L21.1836 31.5469C21.0645 32.1798 21 32.8324 21 33.5C21 33.6472 21.0047 33.7937 21.0107 33.9395L16.207 36.3984L0 28.1055V8.29297L16.207 0L32.4141 8.29297ZM2.06934 26.8604L15.1729 33.5645V16.9316L10 14.4434V20.2451L9.82031 20.0664C9.7614 20.0055 9.70301 19.943 9.64551 19.8799L9.30859 19.4941C9.20206 19.3674 9.03409 19.1428 8.85059 18.9053C8.57142 18.5439 8.25418 18.1542 8.05273 18.0391L8.02051 18.0215C7.9584 17.994 7.88889 17.9788 7.81348 17.9736C7.80934 17.9734 7.80495 17.9729 7.80078 17.9727C7.2386 17.943 6.36441 18.4467 5.8623 18.4912V12.4531L2.06934 10.6279V26.8604ZM10.8594 12.582L16.207 15.1533L29.1523 8.92773L23.3887 5.97852L10.8594 12.582ZM3.26074 8.92773L6.85254 10.6553L19.5498 4.01367L16.207 2.30371L3.26074 8.92773Z",
    fill: "#9D9EB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3883 30.2167C35.7732 29.9101 36.344 29.9286 36.707 30.2738C37.0699 30.619 37.0962 31.168 36.7832 31.5426L36.7158 31.6152L31.1979 37L26.3318 32.8454L26.2596 32.7766C25.9216 32.4229 25.9095 31.8731 26.2476 31.5055C26.5859 31.1378 27.1547 31.0831 27.5599 31.3642L27.6385 31.4245L31.1073 34.386L35.3145 30.2823L35.3883 30.2167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit1Off);
export default __webpack_public_path__ + "static/media/transit1Off.82e640370f2ca63e75a815dc66fc3f04.svg";
export { ForwardRef as ReactComponent };